export default __webpack_public_path__ + "static/media/asset lock.fc3a8b1f.png";